// Zendesk Widget Documentation:
// https://developer.zendesk.com/api-reference/widget/core

import { getDeepProperty } from '@/helpers/deepObject.js'
import api from '@/services/api'

let userMetadata = {
  activePodcastId: null
}

export default {
  bootChat (zendesk, user, podcast) {
    userMetadata.activePodcastId = podcast && podcast.id

    // when a user opens a ticket, send the metadata to zendesk
    zendesk('webWidget:on', 'userEvent', function (event) {
      if (!userMetadata.activePodcastId) {
        return
      }

      if (event.action === 'Contact Form Submitted' || event.action === 'Chat Request Form Submitted' || event.action === 'Chat Opened') {
        let payload = { podcast: userMetadata.activePodcastId }
        api.post('/zendesk/ticket', payload)
      }
    })

    zendesk('webWidget', 'identify', {
      name: user.name || '',
      email: user.email
    })
  },
  // this gets called every time a user logs in, so we can add metadata to their user object
  zendeskUserMetadata (podcastId) {
    if (podcastId) {
      api.post('/zendesk/user', { podcast: podcastId })
    }
  },
  hasZendesk (user) {
    const accountCollection = getDeepProperty(user, 'accounts.collection') || []
    const hasCalisto = accountCollection.filter((account) => getDeepProperty(account, 'features.has_calisto')).length > 0
    const isEnterprise = accountCollection.filter((account) => getDeepProperty(account, 'is_custom_plan')).length > 0

    return isEnterprise && !hasCalisto
  },

  updateChat (podcast) {
    userMetadata.activePodcastId = podcast && podcast.id
  }
}
